module.exports = __webpack_public_path__ + "img/title.ebc70eaf.png";